import axios from "axios";
import apiURI from "./Api";

export default class SubnetService {
  async getBelongsToSubnet(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/subnet/belongsToSubnet`,
      headers: { Authorization: "Bearer " + token },
    });
    return response.data?.result ?? null;
  }

  async getSubnetMember(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/subnet/getSubnetMember`,
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  }

  async getPDFByUsername(username) {
    const response = await axios.get(`${apiURI}/subnet/getPDFByUsername/${username}`);
    return response.data;
  }

  async interestedInService(token, serviceDescription, subnetId) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/subnet/interestInService`,
      data: {
        serviceDescription: serviceDescription,
        subnetId: subnetId,
      },
      headers: { Authorization: "Bearer " + token },
    });
    return response.data ?? null;
  }

  async geolocalizedSearch(token, { distance, query, currentLatitude, currentLongitude }) {
    const data = {
      distance: Number(distance),
      query: query || "",
    };
    if (
      currentLatitude != null &&
      currentLongitude != null &&
      currentLatitude !== 0 &&
      currentLongitude !== 0
    ) {
      data.currentLatitude = Number(currentLatitude);
      data.currentLongitude = Number(currentLongitude);
    }
    const response = await axios({
      method: "post",
      url: `${apiURI}/subnet/geolocalizedSearch`,
      headers: { Authorization: "Bearer " + token },
      data,
    });
    return response.data;
  }
}
